import mountNecessityAndProportionalityParams from './mountNecessityAndProportionalityParams'

const dataLifeCycle = {
  mountNecessityAndProportionalityParams,
}

export default dataLifeCycle
